import LiveSearch from './../components/live-search.js';
import Twig from 'twig';

let Fairgrounds = {}

$(document).ready(function($) {
    if($('[data-search-filter-panel-map]').length) {
        // Живой поиск
        LiveSearch.init({
            renderCallback: function(items){
                let textLink = ($("html").attr("lang")  === "en") ? "Go to" : "Перейти";

                let $result = '<div class="container">'+
                                '<div class="result-search-filter-panel"><div class="nano"><div class="nano-content">';

                let templateItem =  Twig.twig({ data: 
                    '<div class="item-result-filter-panel">'+
                        '{% if data.title|length %}'+
                            '<div class="item-result-filter-panel__title">{{ data.title }}</div>'+
                        '{% endif %}'+
                        '{% if data.descr|length %}'+
                            '<div class="item-result-filter-panel__descr">{{ data.descr }}</div>'+
                        '{% endif %}'+
                        '{% if data.link|length %}'+
                            '<a href="{{ data.link }}" class="item-result-filter-panel__link">' + textLink + '</a>'+
                        '{% endif %}'+
                    '</div>'
                });

                $.each(items, function(key, item) {
                    $result += templateItem.render({ data: {
                        title: item.name,
                        descr: item.description,
                        link:  item.link
                    }});
                });

                $result += '</div></div></div></div>';

                return $result;
            }
        });
    }
})


// WEBPACK FOOTER //
// ./pages/fairgrounds.js